"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cell = exports.Header = exports.Table = void 0;
const stitches_config_1 = require("../../../../../stitches.config");
exports.Table = (0, stitches_config_1.styled)("table", {
    width: "100%",
    color: stitches_config_1.colors.contentPrimary,
});
exports.Header = (0, stitches_config_1.styled)("thead", {
    color: stitches_config_1.colors.contentSecondary,
    fontSize: stitches_config_1.fontSizes.body3,
    variants: {
        showHeader: {
            false: {
                display: "none",
            },
        },
    },
});
exports.Cell = (0, stitches_config_1.styled)("td", {
    padding: "12px",
    borderBottom: stitches_config_1.borderStyles.solid,
    variants: {
        isTable: {
            false: {
                borderBottom: "none",
            },
        },
        isRadio: {
            true: {
                width: "34px",
            },
        },
        isCustom: {
            true: {
                padding: "4px 5px",
                "&input": {
                    paddingLeft: "7px",
                },
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWRpdE1vZGFsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vY29tcG9uZW50cy9BZGRyZXNzUGFuZWwvUHJvcGVydHlPdmVydmlldy9GSVJNSW5mby9fX3N0eWxlc19fL0VkaXRNb2RhbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvRUFLd0M7QUFFM0IsUUFBQSxLQUFLLEdBQUcsSUFBQSx3QkFBTSxFQUFDLE9BQU8sRUFBRTtJQUNuQyxLQUFLLEVBQUUsTUFBTTtJQUNiLEtBQUssRUFBRSx3QkFBTSxDQUFDLGNBQWM7Q0FDN0IsQ0FBQyxDQUFDO0FBRVUsUUFBQSxNQUFNLEdBQUcsSUFBQSx3QkFBTSxFQUFDLE9BQU8sRUFBRTtJQUNwQyxLQUFLLEVBQUUsd0JBQU0sQ0FBQyxnQkFBZ0I7SUFDOUIsUUFBUSxFQUFFLDJCQUFTLENBQUMsS0FBSztJQUV6QixRQUFRLEVBQUU7UUFDUixVQUFVLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0wsT0FBTyxFQUFFLE1BQU07YUFDaEI7U0FDRjtLQUNGO0NBQ0YsQ0FBQyxDQUFDO0FBRVUsUUFBQSxJQUFJLEdBQUcsSUFBQSx3QkFBTSxFQUFDLElBQUksRUFBRTtJQUMvQixPQUFPLEVBQUUsTUFBTTtJQUNmLFlBQVksRUFBRSw4QkFBWSxDQUFDLEtBQUs7SUFFaEMsUUFBUSxFQUFFO1FBQ1IsT0FBTyxFQUFFO1lBQ1AsS0FBSyxFQUFFO2dCQUNMLFlBQVksRUFBRSxNQUFNO2FBQ3JCO1NBQ0Y7UUFDRCxPQUFPLEVBQUU7WUFDUCxJQUFJLEVBQUU7Z0JBQ0osS0FBSyxFQUFFLE1BQU07YUFDZDtTQUNGO1FBQ0QsUUFBUSxFQUFFO1lBQ1IsSUFBSSxFQUFFO2dCQUNKLE9BQU8sRUFBRSxTQUFTO2dCQUVsQixRQUFRLEVBQUU7b0JBQ1IsV0FBVyxFQUFFLEtBQUs7aUJBQ25CO2FBQ0Y7U0FDRjtLQUNGO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtcbiAgYm9yZGVyU3R5bGVzLFxuICBjb2xvcnMsXG4gIGZvbnRTaXplcyxcbiAgc3R5bGVkLFxufSBmcm9tIFwiLi4vLi4vLi4vLi4vLi4vc3RpdGNoZXMuY29uZmlnXCI7XG5cbmV4cG9ydCBjb25zdCBUYWJsZSA9IHN0eWxlZChcInRhYmxlXCIsIHtcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBjb2xvcjogY29sb3JzLmNvbnRlbnRQcmltYXJ5LFxufSk7XG5cbmV4cG9ydCBjb25zdCBIZWFkZXIgPSBzdHlsZWQoXCJ0aGVhZFwiLCB7XG4gIGNvbG9yOiBjb2xvcnMuY29udGVudFNlY29uZGFyeSxcbiAgZm9udFNpemU6IGZvbnRTaXplcy5ib2R5MyxcblxuICB2YXJpYW50czoge1xuICAgIHNob3dIZWFkZXI6IHtcbiAgICAgIGZhbHNlOiB7XG4gICAgICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICAgICAgfSxcbiAgICB9LFxuICB9LFxufSk7XG5cbmV4cG9ydCBjb25zdCBDZWxsID0gc3R5bGVkKFwidGRcIiwge1xuICBwYWRkaW5nOiBcIjEycHhcIixcbiAgYm9yZGVyQm90dG9tOiBib3JkZXJTdHlsZXMuc29saWQsXG5cbiAgdmFyaWFudHM6IHtcbiAgICBpc1RhYmxlOiB7XG4gICAgICBmYWxzZToge1xuICAgICAgICBib3JkZXJCb3R0b206IFwibm9uZVwiLFxuICAgICAgfSxcbiAgICB9LFxuICAgIGlzUmFkaW86IHtcbiAgICAgIHRydWU6IHtcbiAgICAgICAgd2lkdGg6IFwiMzRweFwiLFxuICAgICAgfSxcbiAgICB9LFxuICAgIGlzQ3VzdG9tOiB7XG4gICAgICB0cnVlOiB7XG4gICAgICAgIHBhZGRpbmc6IFwiNHB4IDVweFwiLFxuXG4gICAgICAgIFwiJmlucHV0XCI6IHtcbiAgICAgICAgICBwYWRkaW5nTGVmdDogXCI3cHhcIixcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn0pO1xuIl19